<div class="header">
    <a href="http://www.bnp.gob.pe/" target="_blank">
        <img src="/assets/img/serviciosbnp/logo-bnp.png" alt="Logo" class="logo">
    </a>
    <h1 class="titulo">SERVICIOS EN LÍNEA DE LA BIBLIOTECA NACIONAL DEL PERÚ</h1>
</div>

<body style="background: url('/assets/img/serviciosbnp/fondo-bnp.png'); background-size: cover;" >
    <div class="cuerpo">
        <div class="container">
            <div style="font-family: Arial, Helvetica, sans-serif;">
                <h2>Consultas en línea</h2>
            </div>
            <div class="row"> <!-- Cambiado a 'row' -->
                <div class="col"> <!-- Cambiado a 'col' -->
                    <div class="cuadro">
                        <a href="https://consultas.bnp.gob.pe/bnp/chat.aspx" target="_blank">
                            <img src="/assets/img/serviciosbnp/chatea-con-un-bibliotecario.png" alt="Imagen 1">
                        </a>
                        <p>Chatea con un<br /> bibliotecario</p>
                    </div>
                </div>
                <div class="col"> <!-- Cambiado a 'col' -->
                    <div class="cuadro">
                        <a href="https://consultas.bnp.gob.pe/bnp/consultaelectronica.aspx" target="_blank">
                            <img src="/assets/img/serviciosbnp/consulta-electronica.png"/>
                        </a>
                        <p>Consulta<br /> electrónica</p>
                    </div>
                </div>
                <div class="col"> <!-- Cambiado a 'col' -->
                    <div class="cuadro">
                        <a href="https://www.bnp.gob.pe/colecciones/catalogo/#" target="_blank">
                            <img src="/assets/img/serviciosbnp/catalogo-general.png"/>
                        </a>
                        <p>Catálogo<br /> general</p>
                    </div>
                </div>
                <div class="col"> <!-- Cambiado a 'col' -->
                    <div class="cuadro">
                        <a href="https://sigebi.bnp.gob.pe/circulacion/bnp/prestamo/solicitud" target="_blank">
                            <img src="/assets/img/serviciosbnp/reserva-sala-estudio.png"/>
                        </a>
                        <p>Reserva de espacio<br /> en sala de estudio</p>
                    </div>
                </div>
            </div>
    
        </div>
        
    
        <div class="container">
            <div style="color: #e7b64c; font-family: Arial, Helvetica, sans-serif;">
                <h2>Plataformas Digitales</h2>
            </div>
            <div class="row"> <!-- Cambiado a 'row' -->
                <div class="col"> <!-- Cambiado a 'col' -->
                    <div class="cuadro">
                        <a href="https://bibliotecadigital.bnp.gob.pe/home" target="_blank">
                            <img src="/assets/img/serviciosbnp/biblioteca-digital-libros-gratis.png" alt="Imagen 1">
                        </a>
                        <p>Biblioteca<br /> Digital</p>
                    </div>
                </div>
                <div class="col"> <!-- Cambiado a 'col' -->
                    <div class="cuadro">
                        <a href="https://revistafenix.bnp.gob.pe/index.php/fenix" target="_blank">
                            <img src="/assets/img/serviciosbnp/revista-fenix.png"/>
                        </a>
                        <p>Revista<br /> Fénix</p>
                    </div>
                </div>
                <div class="col"> <!-- Cambiado a 'col' -->
                    <div class="cuadro">
                        <a href="https://memoriaperu.bnp.gob.pe/#/" target="_blank">
                            <img src="/assets/img/serviciosbnp/memoria-peru-historia.png"/>
                        </a>
                        <p>Memoria<br /> Perú</p>
                    </div>
                </div>
                <div class="col"> <!-- Cambiado a 'col' -->
                    <div class="cuadro">
                        <a href="https://artsandculture.google.com/partner/national-library-of-peru" target="_blank">
                            <img src="/assets/img/serviciosbnp/google-arte-cultura-biblioteca.png"/>
                        </a>
                        <p>BNP + Google<br /> Arts & Culture</p>
                    </div>
                </div>
            </div>
    
        </div>
        
    </div>
</body>
